module.exports = __webpack_public_path__ + "img/on-duty.f1887864.webp";